import React, {useState, useEffect} from 'react';
import {Route, useHistory} from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import MapIcon from '@mui/icons-material/Map';
import {useContext} from "react";
import {UserContext} from "./UserContext";
import axios from "axios";
import Notifications from "./Notifications";
import ViewTrip from "./ViewTrip";
import websiteLogo from "./images/latest-website-logo-no-background.png"
import {getBearerToken, getServerUrl} from "./utils/utils";

function ResponsiveAppBar({onLoginPage}) {
    const [openTripModal, setOpenTripModal] = useState(false)
    const [selectedTripId, setSelectedTripId] = useState(null)
    const {user} = useContext(UserContext)
    const pages = onLoginPage ? [] : [{name: 'Trips', link: '/'},{name: 'National-Parks-Tracker', link: '/nationalParksFour'}, {name: 'NFL-tracker', link: '/nfl'}, {name: 'United-States-tracker', link: '/unitedStates'}, {name: 'Europe-tracker', link: '/europe'}, {name: 'Friends', link: '/friends'}]
    const bucketListMenus = [
        {name: 'United States', link: '/unitedStates'},
        {name: 'Europe', link: '/europe'},
        {name: 'World', link: '/world'},
        {name: 'National Parks', link: '/nationalParks'},
        {name: 'NFL', link: '/nfl'},
        {name: 'MLB', link: '/mlb'}
    ]
    const tripsMenu = {name: 'Trips', link: '/'}
    const friendsMenu = {name: 'Friends', link: '/friends'}
    const settings = onLoginPage ? [] : [{name: 'Profile', link: `/profile/${user?.id}`}, {
        name: 'Logout',
        link: '/logout'
    }]
    let history = useHistory();
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [anchorBucketLists, setAnchorBucketLists] = useState(null);
    const [anchorElNotifications, setAnchorElNotifications] = useState(null);
    const [notifications, setNotifications] = useState([])
    const [notificationResponses, setNotificationResponses] = useState({})

    const fetchNotifications = async () => {
        axios.get(`${getServerUrl()}/notifications`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setNotifications(response.data)
            })
    }


    useEffect(() => {
        if (user?.id) {
            fetchNotifications()
        }
    }, [history?.location, user])


    useEffect(() => {
        if (!anchorElNotifications) {
            const updatedNotifications = notifications.filter(notification => {
                if (notification.type === 'FRIEND') {
                    return !notificationResponses[notification.friend.id] || !notificationResponses[notification.friend.id].type === 'FRIEND'
                } else {
                    return !notificationResponses[notification.taggedUser.id] || !notificationResponses[notification.taggedUser.id].type === 'TRIP'
                }
            })
            if (notifications?.length !== updatedNotifications?.length) {
                setNotifications(updatedNotifications)
            }
        }
    }, [notificationResponses, anchorElNotifications, notifications])

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleOpenBucketListsMenu = (event) => {
        setAnchorBucketLists(event.currentTarget);
    };


    const handleOpenNavigationsMenu = (event) => {
        setAnchorElNotifications(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleCloseBucketListsMenu = () => {
        setAnchorBucketLists(null);
    };

    const handleCloseNotificationsMenu = () => {
        setAnchorElNotifications(null);
    };

    if (!onLoginPage) {
        return (
            <AppBar position="static">
                <ViewTrip open={openTripModal} onClose={() => {
                setOpenTripModal(false)
                    }}
                onTripUpdate={() => {}} selectedTripId={selectedTripId}/>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        {!onLoginPage && (
                            <div onClick={() => history.push("/")}>
                                <MapIcon sx={{display: {xs: 'none', md: 'flex'}, mr: 1}} onClick={() => history.push("/")} style={{height: "60px", cursor: "pointer"}}/>
                            </div>
                        )}
                        {/*<MapIcon sx={{display: {xs: 'none', md: 'flex'}, mr: 1}} onClick={() => history.push("/")}/>*/}
                        {/*<Typography*/}
                        {/*    variant="h6"*/}
                        {/*    noWrap*/}
                        {/*    component="a"*/}
                        {/*    href=""*/}
                        {/*    sx={{*/}
                        {/*        mr: 2,*/}
                        {/*        display: {xs: 'none', md: 'flex'},*/}
                        {/*        fontFamily: 'monospace',*/}
                        {/*        fontWeight: 700,*/}
                        {/*        letterSpacing: '.3rem',*/}
                        {/*        color: 'inherit',*/}
                        {/*        textDecoration: 'none',*/}
                        {/*    }}*/}
                        {/*    onClick={() => history.push("/")}*/}
                        {/*>*/}
                        {/*    MAP-APP*/}
                        {/*</Typography>*/}
                        {!onLoginPage && (
                            <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenNavMenu}
                                    color="inherit"
                                >
                                    <MenuIcon/>
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorElNav}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    open={Boolean(anchorElNav)}
                                    onClose={handleCloseNavMenu}
                                    sx={{
                                        display: {xs: 'block', md: 'none'},
                                    }}
                                >
                                    {pages.map((page) => (
                                        <MenuItem key={page} onClick={() => {
                                            console.log("moving user to page")
                                            history.push(page.link)
                                        }}>
                                            <Typography textAlign="center">{page.name}</Typography>
                                        </MenuItem>
                                    ))}
                                    <MenuItem>test</MenuItem>
                                </Menu>
                            </Box>
                        )}
                        <MapIcon sx={{display: {xs: 'flex', md: 'none'}, mr: 1}} onClick={() => history.push("/")}/>
                        <Typography
                            onClick={() => history.push("/")}
                            variant="h5"
                            noWrap
                            component="a"
                            href=""
                            sx={{
                                mr: 2,
                                display: {xs: 'flex', md: 'none'},
                                flexGrow: 1,
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            MAP-APP
                        </Typography>
                        {!onLoginPage && (
                            <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                                <Button
                                    key={tripsMenu.name}
                                    onClick={() => history.push(tripsMenu.link)}
                                    sx={{my: 2, color: 'white', display: 'block'}}
                                >
                                    {tripsMenu.name}
                                </Button>
                                <Tooltip>
                                    <Button
                                        key={tripsMenu.name}
                                        sx={{my: 2, color: 'white', display: 'block'}}
                                        onClick={handleOpenBucketListsMenu}
                                    >
                                        Bucket Lists
                                    </Button>
                                </Tooltip>
                                <Menu
                                    sx={{mt: '45px'}}
                                    id="menu-appbar"
                                    anchorEl={anchorBucketLists}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorBucketLists)}
                                    onClose={handleCloseBucketListsMenu}
                                >
                                    {bucketListMenus.map((bucketList) => (
                                        <MenuItem key={bucketList} onClick={() => {
                                            history.push(bucketList.link)
                                            handleCloseBucketListsMenu()
                                        }}>
                                            <Typography textAlign="center">{bucketList.name}</Typography>
                                        </MenuItem>
                                    ))}
                                </Menu>
                                <Button
                                    key={friendsMenu.name}
                                    onClick={() => history.push(friendsMenu.link)}
                                    sx={{my: 2, color: 'white', display: 'block'}}
                                >
                                    {friendsMenu.name}
                                </Button>

                            </Box>
                        )}
                        {!onLoginPage && (
                            <>
                                {notifications?.length > 0 && (
                                    <Box sx={{flexGrow: 0}} style={{marginRight: 10}}>
                                        <Tooltip title="Open Notifications">
                                            <IconButton onClick={handleOpenNavigationsMenu} sx={{p: 0}}>
                                                <NotificationsActiveIcon sx={{fontSize: 30, color: 'gold'}}
                                                                         fill="gold"/>
                                            </IconButton>
                                        </Tooltip>
                                        <Menu
                                            className="notifications-menu"
                                            sx={{mt: '45px'}}
                                            id="menu-appbar"
                                            anchorEl={anchorElNotifications}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            keepMounted
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            open={Boolean(anchorElNotifications)}
                                            onClose={handleCloseNotificationsMenu}
                                        >
                                            <Notifications
                                                notifications={notifications}
                                                closeMenu={() => handleCloseNotificationsMenu()}
                                                notificationResponses={notificationResponses}
                                                setNotificationResponses={setNotificationResponses}
                                                setSelectedTripId={tripId => setSelectedTripId(tripId)}
                                                setOpenTripModal={() => setOpenTripModal(true)}
                                            />
                                        </Menu>
                                    </Box>
                                )}
                                <Box sx={{flexGrow: 0}}>
                                    <Tooltip title="Open settings">
                                        <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                                            <Avatar alt="Remy Sharp" src={user.profilePictureUrl}/>
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{mt: '45px'}}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                    >
                                        {settings.map((setting) => (
                                            <MenuItem key={setting} onClick={() => history.push(setting.link)}>
                                                <Typography textAlign="center">{setting.name}</Typography>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </Box>
                            </>
                        )}
                    </Toolbar>
                </Container>
            </AppBar>
        );
    }
    return null
}

export default ResponsiveAppBar;